<template>
  <TheHeader>
    <div class="contents-wrapper-01">
      <div class="bbs_title">
        사입
        <a-button size="large" type="link" shape="circle" icon="reload" @click="refreshSaibs" />
        <p class="flow" v-if="isPC">
          <a-breadcrumb>
            <a-breadcrumb-item>
              <a-icon type="read" />
              <span>사입 현황</span>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-if="['/saib/edit'].includes($router.currentRoute.path)">
              <a-icon type="edit" />
              <span>도매 수정</span>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-if="!['/saib', '/saib/edit'].includes($router.currentRoute.path)">
              <a-icon type="check-circle" />
              <span>도매 선택</span>
            </a-breadcrumb-item>
            <a-breadcrumb-item
              v-if="!['/saib', '/saib/selector', '/saib/edit'].includes($router.currentRoute.path)"
            >
              <a-icon type="form" />
              <span>사입 신청</span>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </p>
        <slot name="buttons" />
        <a-button
          style="margin: 5px;"
          shape="round"
          type="dashed"
          v-if="isPC"
          class="fl-right"
          @click="$router.go(-1)"
          icon="rollback"
        >뒤로가기</a-button>
      </div>
      <div class="acc-content-wrapper type2">
        <slot />
      </div>
    </div>
  </TheHeader>
</template>
<script>
import { mapActions } from "vuex";
import TheHeader from "../TheLayout/TheHeader";

export default {
  name: "TheSaib",
  methods: mapActions(["refreshSaibs"]),
  components: { TheHeader }
};
</script>